import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as n from "react";
import { F as m } from "./ChevronLeft20.CgL7KAAg.js";
import { F as p } from "./ChevronRight20.XQ503sZW.js";
import { c } from "./index.CxSWpsOB.js";
const d = n.forwardRef(({
  onClick: r,
  testId: o,
  right: a,
  className: e,
  disabled: w,
  ...s
}, i) => /* @__PURE__ */ t.jsx("button", { ref: i, type: "button", className: c(e, "tw-border-transparent tw-bg-gray-900 tw-text-base-white tw-body-1-m tw-rounded-circular tw-p-6 tw-w-32 tw-h-32 tw-opacity-70 hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-flex tw-items-center tw-justify-center"), "data-testid": o, onClick: r, disabled: w, ...s, children: a ? /* @__PURE__ */ t.jsx(p, {}) : /* @__PURE__ */ t.jsx(m, {}) }));
d.displayName = "ArrowButton";
export {
  d as A
};
//# sourceMappingURL=ArrowButton.C_hYcEFL.js.map
